import * as React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import { useTranslate, useLocale, useSetLocale, Title } from 'react-admin';
import { makeStyles } from '@material-ui/core/styles';
import { changeTheme } from './actions';
import { AppState } from '../types';
import { themeRegistry } from '../layout/themes';

const useStyles = makeStyles({
    label: { width: '10em', display: 'inline-block', verticalAlign: 'middle' },
    button: { margin: '1em' },
    themeRow: { display: 'flex', flexWrap: 'wrap', alignItems: 'center' },
    swatch: {
        display: 'inline-flex',
        width: 18,
        height: 18,
        borderRadius: '50%',
        marginRight: 8,
        border: '1px solid rgba(0, 0, 0, 0.15)',
        position: 'relative',
        overflow: 'hidden',
    },
    swatchAccent: {
        position: 'absolute',
        right: 0,
        top: 0,
        bottom: 0,
        width: '45%',
    },
});

const Configuration = () => {
    const translate = useTranslate();
    const locale = useLocale();
    const setLocale = useSetLocale();
    const classes = useStyles();
    const theme = useSelector((state: AppState) => state.theme);
    const dispatch = useDispatch();
    return (
        <Card>
            <Title title={translate('pos.configuration')} />
            <CardContent>
                <div className={classes.themeRow}>
                    <div className={classes.label}>
                        {translate('pos.theme.name')}
                    </div>
                    {themeRegistry.map((t) => (
                        <Button
                            key={t.name}
                            variant="contained"
                            className={classes.button}
                            color={theme === t.name ? 'primary' : 'default'}
                            onClick={() => dispatch(changeTheme(t.name))}
                            startIcon={
                                <span
                                    className={classes.swatch}
                                    style={{ backgroundColor: t.swatch.surface }}
                                >
                                    <span
                                        className={classes.swatchAccent}
                                        style={{ backgroundColor: t.swatch.accent }}
                                    />
                                </span>
                            }
                        >
                            {t.label}
                        </Button>
                    ))}
                </div>
            </CardContent>
            <CardContent>
                <div className={classes.label}>{translate('pos.language')}</div>
                <Button
                    variant="contained"
                    className={classes.button}
                    color={locale === 'en' ? 'primary' : 'default'}
                    onClick={() => setLocale('en')}
                >
                    en
                </Button>
                <Button
                    variant="contained"
                    className={classes.button}
                    color={locale === 'fr' ? 'primary' : 'default'}
                    onClick={() => setLocale('fr')}
                >
                    fr
                </Button>
            </CardContent>
        </Card>
    );
};

export default Configuration;
